module.exports = "https://lts-static.prod-my.games/promo/lp1/img/background.216d7ad4.webp";